"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDirectOsysChild = (childEl, parentEl) => {
    const closestOsys = childEl.parentElement
        ? childEl.parentElement.closest('[osys]')
        : null;
    if (closestOsys) {
        if (closestOsys.isSameNode(parentEl)) {
            return true;
        }
        return false;
    }
    return true;
};
//# sourceMappingURL=isDirectOsysChild.js.map